import Vue from 'vue';
import Vuex from 'vuex';
import storage from 'good-storage'
import { Notification } from 'element-ui';
import api from '../api/apifolder';
import menuOperate from './modules/menuOperate';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    game_list: [],
    game_list_obj: {},
    game_id: '', // 平台游戏 ID
    game_area_list: {}, // 数组模式，以game_id为键名，对应值为子游戏数组。
    game_area_obj_list: {}, // 换为对象模式,以game_id为键名, 对应值为以子游戏game_area_id为键名的对象
    curr_game_id: '',
    curr_game_name: '',
    curr_role_id: '',
    permission: {}, // 记录用户在某个平台权限
    permission_obj: {}, // 记录用户所有平台权限
    permission_arr: [], // 拥有的权限
    isShowInVuex: [false, false, false],
    APIType: '初始化当前环境',
    channel_list: [],
    package_list: []
  },
  mutations: {
    // 设置渠道列表
    setChannelList(state, list) {
      state.channel_list = list;
    },
    // 设置游戏包列表
    setPackageList(state, list) {
      state.package_list = list;
    },
    setGameId(state, id) {
      state.game_id = id
    },
    // 保存用户权限
    saveAuthorPermission(state, res) {
      // console.log(res)
      state.permission_arr = res
      const permissionObj = res
      if (permissionObj[-99] !== undefined) {
        state.permission = permissionObj[-99]
      } else {
        state.permission = permissionObj[state.game_id]
      }
    },
    saveAuthorPermissionArr(state, res) {
      state.permission_arr = res
    },
    getGameList(state, res) {
      const newState = state;
      const data = res.data.data;
      storage.remove('GameListInStorage');
      storage.set('GameListInStorage', data);
      data.forEach((item) => {
        const obj = item;
        obj.exist = true;
        newState.game_list_obj[item.game_id] = obj;
      });
      newState.game_list = res.data.data.sort(
        (a, b) => a.game_id - b.game_id,
      );
    },
    getGameListByStorage(state) {
      const newState = state;
      const data = storage.get('GameListInStorage', '');
      data.forEach((item) => {
        const obj = item;
        obj.exist = true;
        newState.game_list_obj[item.game_id] = obj;
      });
      newState.game_list = data.sort(
        (a, b) => a.game_id - b.game_id,
      );
      console.log('成功从缓存中获取GameList')
    },
    getGameAreaList(state, res) {
      const newState = state;
      // 主要用于填充子游戏限免列表
      state.game_area_list[res.id] = res.data.data;

      const itemObj = {};
      res.data.data.forEach((item) => {
        item.game_name = state.game_list_obj[res.id].game_name;
        itemObj[item.game_area_id] = item;
      });
      // 主要用于通过game_id，game_area_id来查找对应数据
      newState.game_area_obj_list[res.id] = itemObj;
    },
    getCurrGameId(state, res) {
      const newState = state;
      if (!res.id) {
        return
      }
      newState.curr_game_id = res.id;
      newState.curr_game_name = state.game_list_obj[res.id] && state.game_list_obj[res.id].game_name;
    },

    getCurrRoleId(state, res) {
      const newState = state;
      newState.curr_role_id = res.id;
    },
    // 当前环境
    getAPITypeInVuex(state, num) {
      state.APIType = num;
    },
  },
  actions: {
    getChannelPackage({ commit }) {
      return new Promise((resolve) => {
        api.standardChannelList({ page: 1, size: 1000, order_by: 'id' })
          .then(({ data }) => {
            commit('setChannelList', data.data)
            return api.appPackageConfigList({ page: 1, size: 10000, order_by: 'id', display_switch: 1 })
          })
          .then(({ data }) => {
            commit('setPackageList', data.data)
            resolve(data.data)
          })
      });
    },
    getGameList({ commit }) {
      return new Promise((resolve) => {
        // const todayDate = getDate(new Date());
        // 隔天访问或被指定需要刷新游戏列表或无缓存时 则重新获取游戏列表数据
        api.getGameList().then((response) => {
          commit({
            type: 'getGameList',
            data: response.data,
          });
          resolve(response);
        }).catch((err) => {
          Notification.warning({
            title: '抱歉',
            message: `获取在线getGameList失败，原因是${err}，请刷新浏览器重试`,
            duration: 8000,
          });
          resolve(err);
        });

        // const mydate = new Date();
        // // console.log('星期几', mydate.getDay());
        // const hasVisitedOn3 = storage.get('hasVisitedOn3');
        // // 非周3的时候将hasVisitedOn3 设置为false
        // if (mydate.getDay() !== 3) {
        //   storage.set('hasVisitedOn3', '');
        // }
        // // 如果今天周3且未被访问过 则获取在线gamelist
        // if ((mydate.getDay()) === 3 && (!hasVisitedOn3)) {
        //   api.getGameList().then((response) => {
        //     commit({
        //       type: 'getGameList',
        //       data: response.data,
        //     });
        //     console.log('今天星期3且今天未访问过在线gamelist，故获取在线gamelist')
        //     storage.set('hasVisitedOn3', true);
        //     resolve(response);
        //   }).catch((err) => {
        //     commit({
        //       type: 'getGameListByStorage',
        //     });
        //     console.log(`获取在线getGameList失败，原因是${err}，已从缓存中获取`);
        //     storage.set('hasVisitedOn3', true);
        //     resolve(err);
        //   });
        // } else {
        //   // 今天不是周三 或者 就算今天是周三但是访问过在线gamelist 则走缓存
        //   console.log(`今天星期${mydate.getDay()}不是星期3 或者虽然今天星期3 但是今天访问过在线gamelist，所以尝试从缓存中获取gamelist`);
        //   if (!storage.get('GameListInStorage')) {
        //     api.getGameList().then((response) => {
        //       commit({
        //         type: 'getGameList',
        //         data: response.data,
        //       });
        //       console.log('在缓存中找不到GameListInStorage 已从网站中获取gamelist');
        //       // storage.set('hasVisitedOn3', true);
        //       setTimeout(() => {
        //         location.reload();
        //         console.log('已刷新')
        //       }, 300);
        //       resolve(response);
        //     }).catch((err) => {
        //       console.log(`获取在线getGameList失败，原因是${err}，且本地无相关缓存....`);
        //       // commit({
        //       //   type: 'getGameListByStorage',
        //       // });
        //       Notification.warning({
        //         title: '抱歉',
        //         message: '您的浏览器未缓存gameList数据且在线接口响应失败，请刷新浏览器再次请求gameList接口',
        //         duration: 8000,
        //       });
        //       resolve(err);
        //     });
        //     console.log('本地无gamelist缓存，已请求在线数据');
        //   } else {
        //     console.log('缓存GameListInStorage存在且今天不是周三 或者就算今天是周三但是访问过在线gamelist 则走缓存')
        //     commit({
        //       type: 'getGameListByStorage',
        //     });
        //   }
        //   resolve('resolve-- 缓存中获取gamelist');
        // }
      });
    },
    getGameAreaList({ commit }, params) {
      return new Promise((resolve) => {
        // console.log(params, '开始获取子游戏');
        api.getGameAreaList({ game_id: params.id }).then((response) => {
          commit({
            type: 'getGameAreaList',
            id: params.id,
            data: response.data,
          });
          resolve(response);
        });
      });
    },
  },
  modules: {
    menuOperate,
  },
});

export default store;
